import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=7fa28147&scoped=true&"
import script from "./StatCard.vue?vue&type=script&lang=ts&"
export * from "./StatCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=7fa28147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa28147",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VIcon,VSkeletonLoader})
